import { api } from '@/lib/api';

const initialState = () => {
  return {
    users: 0,
    sites: 0,
    messages: 0,
    visits: 0,
  };
};

const getters = {
  getUsers: state => state.users,
  getSites: state => state.sites,
  getMessages: state => state.messages,
  getVisits: state => state.visits,
};

const mutations = {
  setUsers(state, users) {
    state.users = users;
  },

  setSites(state, sites) {
    state.sites = sites;
  },

  setMessages(state, messages) {
    state.messages = messages;
  },

  setVisits(state, visits) {
    state.visits = visits;
  },
};

const actions = {
  async fetchStats({ commit }) {
    const {
      data: { sites, messages, users, visits },
    } = await api.get('/performances');

    commit('setUsers', users);
    commit('setSites', sites);
    commit('setMessages', messages);
    commit('setVisits', visits);
  },
};

export default {
  namespaced: true,
  state: initialState(),
  getters,
  mutations,
  actions,
};
